
import http, { Response } from '@utils/http/http';
import * as types from './type';

// 列表接口
export const goodsListApi = (data: types.goodsListParams) =>{
  return http.post<Response<types.goodsListResponse>>('/tfshop/index/goods/shelves',data)
}

// 新购物车 Java 版
// // 
// export const addCartApi = (params = {}) =>{
//   return http.post('/tfshop/cart/addCart',params)
// }


// 商品库存
export const productStockApi = (params = {}, header = {}) =>{
  return http.get('/wanlshop/product/stock',params)
}

// 更改购物车数量
export const setCartNumApi = (params = {}, header = {}) =>{
  return http.post('/wanlshop.cart/setCartNum',params)
}

/**
 * 加车
 */
export const addCartApi = (param = {}) =>{
  return http.post('/tfshop/merchant/newCart/operateCart',{ param })
}

/**
 * 购物车数据
 * 旧的： tfshop/merchant/cart/newCartList
 */
export const cartListApi = (param = {})=>{
  return http.post('/tfshop/merchant/newCart/cartList',{ param })
}

/* 
购物车数量
*/
export const getCartNumApi = (params = {}) => {
  return http.get('/tfshop/merchant/cart/count',params)
}